import { BadPressMatchRecord } from '../../badpress-match.model';
import { Observable } from 'rxjs/Observable';
import { ApplicationValue } from './../../../../../services/warmup/application-type.model';
import { WarmUpService, ApplicationTypeConstants } from './../../../../../services/warmup/warmup.service';
import { ResolveBadPressMatchComponent } from './../resolvebadpress/resolve-badpress.component';
import { Component, OnInit, OnChanges, ViewContainerRef, Input } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';

import { UpdateBadPressMatchComponent } from 'app/entities/monitoring/actual/badpress/badpressmatch/updatebadpressmatch/update-bad-press-match.component';
import { BadPressService } from 'app/entities/monitoring/actual/badpress/bad-press.service';

import { EntityType, EntityIdDetails } from 'app/shared/models/entity-id-details.model';
import { BadPressMatchResponse, BadPressEntity } from 'app/entities/monitoring/actual/badpress-match.model';

@Component({
  selector: 'bad-press-match',
  providers: [BadPressService],
  templateUrl: './bad-press-match.component.html',
  styleUrls: ['./bad-press-match.component.css']
})

/**
 * Component to display the monitoring sanction for the entity.
 */
export class BadPressMatchComponent implements OnInit, OnChanges {
  @Input() entityIdDetails: EntityIdDetails;
  public id: number;
  dialogRef: MdDialogRef<any>;
  badPressMatchData: BadPressMatchResponse;
  badPressMatchLoaded = false;
  matchResolutions: ApplicationValue[];

  constructor(
    public dialog: MdDialog,
    public viewContainerRef: ViewContainerRef,
    private badPressMatchService: BadPressService,
    private snackBarService: SnackBarService,
    private trackingService: TrackingService,
    private warmUpService: WarmUpService) { }

  ngOnInit() {
    this.setUpMatchResolutions(
      this.warmUpService.getApplicationValue(ApplicationTypeConstants.PANAMA_PAPERS_MATCH_RESOLUTION));
  }

  setUpMatchResolutions(dropDownValues: any) {
    if (dropDownValues instanceof Observable) {
      dropDownValues.subscribe(
        response => {
          this.warmUpService.setApplicationTypeInLS(response);
          this.matchResolutions = response.values;
        }
      );
    } else {
      this.matchResolutions = dropDownValues;
    }
  }

  ngOnChanges() {
    if (this.entityIdDetails && this.entityIdDetails.entityId) {
      this.id = this.entityIdDetails.entityId;
      this.getBadPressMatches();
    }
  }

  // Get Monitoring Elaboration Text Description..
  getBadPressMatches() {
    this.badPressMatchLoaded = false;
    this.badPressMatchService.getBadPressInfoMatches(this.id, this.entityIdDetails.entityType)
      .subscribe(response => {
        this.badPressMatchData = response;
        this.badPressMatchLoaded = true;
      });
  }

  // Open dialog having text editor to update Monitoring Elaboration text.
  openBadPressMatchUpdateDialog() {
    const config = new MdDialogConfig();
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(UpdateBadPressMatchComponent, config);
    this.dialogRef.componentInstance.argId = this.id;
    this.dialogRef.componentInstance.argEntityType = this.entityIdDetails.entityType;
    this.dialogRef.componentInstance.argBadPressMatchDetailsData = this.badPressMatchData;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      this.getBadPressMatches();
    });
  }

  resolveBadPressMatch(badPressMatchRecord: BadPressMatchRecord, relationEntityId: number) {
    const config = new MdDialogConfig();
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(ResolveBadPressMatchComponent, config);
    this.dialogRef.componentInstance.badPressMatchRecord = badPressMatchRecord;
    this.dialogRef.componentInstance.relationEntityId = relationEntityId;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      if (result) {
        this.getBadPressMatches();
      }
    });
  }

  toJson(jsonData) {
    return JSON.parse(jsonData);
  }

  getMatchStatus(matchId) {
    if (this.matchResolutions) {
      const match = this.matchResolutions.find(matchResolution => matchResolution.id === matchId);
      if (match) {
        return match.name;
      }
    }
    return 'Probable';
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/actual/badpress/badpressmatch/bad-press-match.component.ts